module.exports = __webpack_public_path__ + "img/download_header_common.a9da1a2e.png";